<template>
  <v-container fluid class="pa-8">
    <v-row class="mb-6">
      <v-col cols="12">
        <v-btn 
          text 
          color="grey" 
          class="px-0 mb-6 text-none font-weight-bold" 
          @click="$router.push({ name: rutaInventario('listado') })"
        >
          <v-icon left small>mdi-arrow-left</v-icon> Volver al historial de informes
        </v-btn>

        <div class="d-flex align-center justify-space-between flex-wrap">
          <div>
            <div class="d-flex align-center mb-1">
              <v-chip x-small color="green darken-4" dark class="font-weight-black mr-3">FINALIZADO</v-chip>
              <span class="grey--text text-overline font-weight-black letter-spacing-1">Resumen del Informe</span>
            </div>
            <h1 class="white--text text-h3 font-weight-black mb-2">
              Auditoría de Stock
            </h1>
            <div class="d-flex align-center flex-wrap">
              <div class="d-flex align-center mr-6 mb-2">
                <v-icon x-small color="grey" class="mr-2">mdi-identifier</v-icon>
                <span class="grey--text font-mono text-caption">ID: {{ $route.params.inventarioUuid }}</span>
              </div>
              <div class="d-flex align-center mr-6 mb-2">
                <v-icon x-small color="grey" class="mr-2">mdi-calendar-clock</v-icon>
                <span class="grey--text text-caption">Cerrado el: {{ formatFecha(resumen.fecha_cierre) }}</span>
              </div>
              <div class="d-flex align-center mb-2">
                <v-icon x-small color="grey" class="mr-2">mdi-account-outline</v-icon>
                <span class="grey--text text-caption">Auditado por: {{ resumen.usuario || 'Sistema' }}</span>
              </div>
            </div>
          </div>

          <div class="d-flex align-center mt-4 mt-md-0">
            <v-btn outlined color="grey darken-2" class="white--text text-none font-weight-black rounded-lg mr-3 px-4">
              <v-icon left size="18">mdi-printer-outline</v-icon> IMPRIMIR
            </v-btn>
            <v-btn outlined color="grey darken-2" class="white--text text-none font-weight-black rounded-lg px-4">
              <v-icon left size="18">mdi-download-outline</v-icon> EXCEL
            </v-btn>
          </div>
        </div>

        <v-divider class="grey darken-4 my-8"></v-divider>

        <div class="report-main-container pa-6 rounded-xl border-subtle bg-dark-refined shadow-lg">
          <SucursalInventarioResumen
            :inventarioUuid="$route.params.inventarioUuid"
          ></SucursalInventarioResumen>
        </div>

        <div class="mt-8 pa-4 rounded-lg bg-info-soft border-subtle d-flex align-center">
          <v-icon color="blue-grey lighten-2" class="mr-4">mdi-information-variant</v-icon>
          <span class="grey--text text-caption">
            Este informe es un documento de auditoría finalizado. Los valores aquí presentados reflejan la diferencia entre el stock de sistema y el conteo físico en el momento del cierre.
          </span>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import inventarioMixin from "@/mixins/inventario.mixin";
import moment from "moment";
import InventarioAPI from "@/api/inventario";
import SucursalInventarioResumen from "@/views/empresa/sucursales/productos/inventario/components/SucursalInventarioResumen.vue";

export default {
  mixins: [inventarioMixin],
  name: "SucursalProductosInventarioResumen",
  components: { SucursalInventarioResumen },
  data() {
    return {
      resumen: {
        uuid: "",
        fecha_inicio: "",
        fecha_cierre: "",
        sucursal: "",
        usuario: "",
        categorias: [],
        totales: {},
      },
    };
  },
  created() {
    this.fetchResumen();
  },
  methods: {
    fetchResumen() {
      const inventarioUuid = this.$route.params.inventarioUuid;
      InventarioAPI.getResumen(inventarioUuid)
        .then((response) => {
          this.resumen = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener resumen de inventario:", error);
        });
    },
    formatFecha(fecha) {
      if (!fecha) return "---";
      return moment(fecha).format("DD [de] MMMM, YYYY [a las] HH:mm");
    }
  },
};
</script>

<style scoped>
/* ESTÉTICA DARK REFINED */
.bg-dark-refined { 
  background-color: #161616; 
}

.bg-info-soft {
  background-color: rgba(255, 255, 255, 0.02);
}

.border-subtle { 
  border: 1px solid #222 !important; 
}

.font-mono { 
  font-family: 'Roboto Mono', monospace !important; 
}

.letter-spacing-1 { 
  letter-spacing: 1.2px; 
}

h1 { 
  letter-spacing: -1.5px !important;
  line-height: 1.1;
}

/* Ajustes para que el componente hijo no traiga estilos blancos */
.report-main-container >>> .v-card {
  background-color: transparent !important;
  box-shadow: none !important;
}

.report-main-container >>> .v-data-table {
  background-color: transparent !important;
  color: #eee !important;
}
</style>